<template>
<div class="homework">
  <h4>Домашнее задание</h4>

  <button type="button" class="header-menu__btn" @click="openPopup('AddHomework', null)">
    <i class="fas fa-plus"></i>
    Добавить задание
  </button>

  <hr>

  <div v-if="isMaster" class="homework__auto">
    <AutoHomeworkItems v-if="class_id && item" :item="item" :class_id="class_id" />

    <hr>
  </div>

  <ul v-if="homework" class="homework__list">
    <li v-for="(item, k) in homework" :key="item.id">
      <HomeworksItem 
        @edit-homework="openPopup('AddHomework', $event)" 
        :items="item" 
        :date="k" 
        :key="item.id" 
      />
    </li>
  </ul>

  <Popup :isOpened="popupIsOpened" @close="popupIsOpened = false">
    <template v-slot:content>
      <component 
        :is="popupContent" 
        :data="popupData" 
        :class_students="item.students" 
        :class_id="item.id" 
        @close-popup="popupIsOpened = false" 
        @add-homework="updateHomework"
      ></component>
    </template>
  </Popup>
</div>
</template>

<script>
import AddHomework from "./AddHomework";
import HomeworksItem from "./HomeworksItem";
import AutoHomeworkItems from "./AutoHomeworkItems";
import ClassMedia from './ClassMedia'
import {
  mapGetters,
  mapActions
} from 'vuex'
import { popup_mix } from '../../../mixins/popup_mix'

export default {
  name: "homework-list",
  inject: ['http'],
  mixins: [popup_mix],
  components: {
    AddHomework,
    ClassMedia,
    AutoHomeworkItems,
    HomeworksItem
  },
  data() {
    return {
      items: '',
      lesson: '',
      editorConfig: {}
    }
  },
  provide() {
    return {
      isMaster: +this.isMaster
    }
  },
  props: ['class_id', 'item'],
  computed: {
    ...mapGetters({
      user: 'user',
      homework: 'teacher/homework'
    }),
    isMaster() {
      return (this.user.property && this.user.property.is_master) ? this.user.property.is_master : false;
    }
  },
  methods: {
    ...mapActions({
      getHomework: 'teacher/getHomework'
    }),
    async updateHomework() {
      await this.getHomework(this.$route.params.id)
      swal('Успешно!', "Задание обновлено", "success");
    },
    init() {
      try {
        this.lesson = this.item.params.current_lesson
      } catch {}
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.homework {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 600px;
}
.homework__auto,
.homework__list {
  width: 100%;
}
.homework__list {
  padding: 0;
  margin: 0;
  list-style: none;
}
</style>
